import {
  confirmResetPassword,
  confirmSignIn,
  fetchAuthSession,
  fetchUserAttributes,
  resetPassword,
  signIn,
  signOut,
  updatePassword,
  updateUserAttributes,
} from 'aws-amplify/auth'

export interface UserAttributes {
  sub: string
  email: string
  name: string
  given_name: string
  family_name: string
  email_verified?: string
  updated_at?: string
  'custom:tenantId': string
  'custom:optInMarketing'?: string
}

export const authService = {
  signIn,
  confirmSignIn,
  signOut,
  updatePassword,
  resetPassword,
  confirmResetPassword,
  updateUserAttributes,
  fetchAuthSession,
  fetchUserAttributes,
}
